import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useParams, useLocation, useHistory } from "react-router-dom"
import { notification } from "antd"

import RunSummary from "./components/RunSummary"
import PreflightFindings from "./components/PreflightFindings"
import { fetchPreflight, fetchRunBills, flagRecheckSummary, recheckFlags } from "./clientBatchingSlice"

export default function RunPreflightPage() {
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()
    const { runId } = useParams()

    useEffect(() => {
        const load = async () => {
            // Red flags first (A/R feedback item 1): it can move bills in or out of the run, and
            // both the header and the findings below should describe the run AFTER that.
            const flags = await dispatch(recheckFlags(runId))
            const moved = flagRecheckSummary(flags)

            // The run header comes from the bills endpoint; pre-flight is its own call.
            dispatch(fetchRunBills(runId, { pagination: { current: 1, pageSize: 1 }, persistPagination: false }))
            // Always re-checked on arrival (force): the reviewer may have just fixed something in
            // another tab, and a cached list would show findings that are already gone.
            const response = await dispatch(fetchPreflight(runId, { force: true }))

            // Arriving from Update on Review Bills: say what the re-check found. Otherwise only
            // speak up when red flags actually moved bills.
            const fromUpdate = location.state && location.state.recheck
            if (fromUpdate) history.replace(location.pathname) // once only, not again on refresh
            const summary = response && !response.error && response.data && response.data.summary

            if (fromUpdate && !summary) {
                notification.error({ message: "Pre-flight could not be re-checked. Try Re-check." })
            } else if (fromUpdate) {
                notification.success({
                    message: "Pre-flight re-checked",
                    description: [summary.total ? `${summary.total} finding(s) left.` : "Nothing left to fix.", moved]
                        .filter(Boolean)
                        .join(" "),
                })
            } else if (moved) {
                notification.info({ message: "Red flags re-checked", description: `${moved}.` })
            }
        }
        load()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, runId])

    return (
        <div>
            <RunSummary />
            <div style={{ marginTop: "20px" }}>
                <PreflightFindings />
            </div>
        </div>
    )
}
